import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgBnb = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#bnb_svg__a)'>
      <path fill='#F3BA2F' d='M24 12q0 12-12 12T0 12 12 0t12 12' />
      <path
        fill='#fff'
        d='M8.504 10.564 12 7.068l3.497 3.497 2.034-2.034L12 3 6.47 8.53zM3 12l2.034-2.034L7.068 12l-2.034 2.034zm5.504 1.437L12 16.932l3.497-3.497 2.035 2.033L12 21l-5.532-5.533zM16.932 12l2.034-2.034L21 12l-2.034 2.034z'
      />
      <path
        fill='#fff'
        d='M14.063 11.999 12 9.935l-2.062 2.062-.003.003.003.003L12 14.065l2.064-2.064.001-.001z'
      />
    </g>
    <defs>
      <clipPath id='bnb_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgBnb)
export default ForwardRef
